import cn from 'classnames';
import React from 'react';

import { Divider, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { INamesType } from '../../interfaces/reviews';
import { CreateReviewButton } from '../CreateReviewButton';

import { HowWeWork } from './components/HowWeWork';
import styles from './side-block.module.scss';

export type TSideBlockProps = {
  title?: string;
  namesType: INamesType;
  description?: string;
  titleLevel?: 4 | 6 | 1 | 2 | 3 | 5;
  hasButton?: boolean;
};

export const SideBlock: React.FC<TSideBlockProps> = ({ title, description, titleLevel, namesType, hasButton }) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.wrapper}>
      {title && <Typography.Heading level={titleLevel || 4}>{title}</Typography.Heading>}
      {description && (
        <Typography.Text size={14} className={'h-mt-8'}>
          {description}
        </Typography.Text>
      )}
      {hasButton && (
        <Space
          justify={'stretch'}
          className={cn({ [styles.fixedButtonWrapper]: isMobile }, !isMobile && 'h-mt-24 h-mb-8')}
        >
          <div className={styles.buttonWrapper}>
            <CreateReviewButton isMobile={isMobile} />
          </div>
        </Space>
      )}
      {!isMobile && (
        <>
          <Divider size={24} />
          <HowWeWork namesType={namesType} />
        </>
      )}
    </div>
  );
};
